import plusFill from '@iconify/icons-eva/plus-fill';
import saveIcon from '@iconify/icons-eva/save-outline';
import closeIcon from '@iconify/icons-eva/close-circle-outline';
import { Icon } from '@iconify/react';
// material
import {
  Button,
  Card,
  Container,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
  Typography,
  useMediaQuery
} from '@mui/material';
import { filter } from 'lodash';
import { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useSelector } from 'react-redux';

//
import { useFormik } from 'formik';
import {
  UserListHead,
  UserListToolbar,
  UserMoreMenu,
  ImportFile,
  UserMoreInfo
} from '../components/user';
import Label from '../components/Label';
// components
import Page from '../components/Page';
import Scrollbar from '../components/Scrollbar';
import SearchNotFound from '../components/SearchNotFound';
import { TableFilterSidebar } from '../components/sidebarFilter';
import { useTranslation } from '../common/LocalizationProvider';

import {
  selectSession,
  selectGroupSelectedId,
  selectGroupsArray,
  selectUsersArray
} from '../createSelectorUtils';
// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }

  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_user) =>
        (_user.name
          ? String(_user.name).toLowerCase().indexOf(query.toLowerCase()) !== -1
          : false) ||
        (_user.prenom
          ? String(_user.prenom).toLowerCase().indexOf(query.toLowerCase()) !== -1
          : false) ||
        (_user.email
          ? String(_user.email).toLowerCase().indexOf(query.toLowerCase()) !== -1
          : false) ||
        (_user.niveau
          ? String(_user.niveau).toLowerCase().indexOf(query.toLowerCase()) !== -1
          : false) ||
        (_user.status
          ? String(_user.status).toLowerCase().indexOf(query.toLowerCase()) !== -1
          : false) ||
        (_user.groupName
          ? _user.groupName.toLowerCase().indexOf(query.toLowerCase()) !== -1
          : false) ||
        (_user.phone ? _user.phone.indexOf(query) !== -1 : false)
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function User() {
  const t = useTranslation();

  const hiddenDown = useMediaQuery((theme) => theme.breakpoints.between('xs', 'sm'));

  const [openFilter, setOpenFilter] = useState(false);

  const [tableHead, setTableHead] = useState([]);

  const correspondLevel = (level) => {
    switch (level) {
      case 'student':
        return t('fields_Student');
      case 'studentSolo':
        return t('fields_Student_Solo');
      case 'licensedPilot':
        return t('fields_Licensed_Pilot');
      case 'instructor':
        return t('fields_Instructor');
      default:
        return '';
    }
  };

  const formik = useFormik({
    initialValues: {
      club: null,
      status: null,
      level: null
    },
    onSubmit: () => {
      setOpenFilter(false);
    }
  });
  const { resetForm, handleSubmit } = formik;

  const handleOpenFilter = () => {
    setOpenFilter(true);
  };

  const handleCloseFilter = () => {
    setOpenFilter(false);
  };

  const handleResetFilter = () => {
    handleSubmit();
    resetForm();
  };

  // ----------------------------------------------------------------------

  const session = useSelector(selectSession);
  const groupId = useSelector(selectGroupSelectedId);
  const groups = useSelector(selectGroupsArray);

  const permission = session.permission
    ? session.permission.find((item) => item.groupid === groupId) || {}
    : {};
  const selectorUsers = useSelector(selectUsersArray);

  const [users, setUsers] = useState([]);

  useEffect(() => {
    if (selectorUsers) {
      let items = [];
      selectorUsers.map((item) =>
        item && item.permission && item.permission.length > 0
          ? item.permission.map((i) =>
              items.push({ ...item, groupId: i.groupid, statusValue: i.status })
            )
          : items.push({ ...item, groupId: -1, statusValue: -1 })
      );

      if (formik.values.level != null) {
        items = items.filter((item) => item.niveau === formik.values.level.value);
      }
      if (formik.values.user != null) {
        items = items.filter((item) => item.id === formik.values.user.id);
      }

      if (formik.values.club != null) {
        items = items.filter((item) => item.groupId === formik.values.club.id);
      }

      if (groupId !== 0) {
        items = items.filter((item) => item.groupId === groupId);
      }

      if (formik.values.status != null) {
        items = items.filter((item) => item.statusValue === formik.values.status.value);
      }

      items = items.map((item) => {
        const group = groups.find((group) => group.id === item.groupId);
        const correspondStatus = (status) => {
          switch (status) {
            case 0:
              return t('fields_Admin');
            case 1:
              return t('fields_Manager');
            case 2:
              return t('fields_Instructor');
            case 3:
              return t('fields_Pilot+');
            case 4:
              return t('fields_Pilot');
            default:
              return '';
          }
        };
        if (group) {
          return {
            ...item,
            status: correspondStatus(item.statusValue),
            groupName: group.name
          };
        }
        return {
          ...item,
          status: '',
          groupName: ''
        };
      });
      setUsers(items);
    }
  }, [selectorUsers, formik.values, groupId, groups, t]);

  const [openProgress, setOpenProgress] = useState(false);
  const [importedUser, setImportedUser] = useState([]);

  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('name');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
    setPage(0);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - users.length) : 0;

  const filteredUsers =
    importedUser.length === 0
      ? applySortFilter(users, getComparator(order, orderBy), filterName)
      : importedUser;

  const isUserNotFound = filteredUsers.length === 0;

  useEffect(() => {
    const INITIAL_TABLE_HEAD = [
      { id: 'name', label: t('fields_LastName'), alignRight: false, display: undefined },
      { id: 'prenom', label: t('fields_FirstName'), alignRight: false, display: undefined },
      { id: 'email', label: t('fields_Email'), alignRight: false, display: undefined },
      { id: 'phone', label: t('fields_Phone'), alignRight: false, display: undefined },
      { id: 'niveau', label: t('fields_Level'), alignRight: false, display: undefined },
      { id: 'status', label: t('fields_Status'), alignRight: false, display: undefined },
      { id: 'groupName', label: t('fields_Club'), alignRight: false, display: undefined },
      { id: '' }
    ];

    if (hiddenDown) {
      const newTableHead = INITIAL_TABLE_HEAD.map((item) =>
        item.id !== 'name' && item.id !== 'prenom' ? { ...item, display: 'none' } : item
      );
      setTableHead(newTableHead);
    } else {
      setTableHead(INITIAL_TABLE_HEAD);
    }
  }, [hiddenDown, t]);

  return (
    <Page title={t('UL_Title')} openProgress={openProgress}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            {t('usersList')}
          </Typography>
          {importedUser.length === 0 && (permission.status < 3 || session.administrator) ? (
            <Button
              variant="contained"
              component={RouterLink}
              to="add"
              startIcon={<Icon icon={plusFill} />}
            >
              {t('usersNew')}
            </Button>
          ) : (
            <Stack direction="row" spacing={1} flexShrink={0} sx={{ my: 1 }}>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => setImportedUser([])}
                startIcon={<Icon icon={closeIcon} />}
              >
                {t('btn_Cancel')}
              </Button>
              <Button
                variant="contained"
                onClick={() => setOpenProgress(true)}
                startIcon={<Icon icon={saveIcon} />}
                color="secondary"
              >
                {t('btn_Save')}
              </Button>
            </Stack>
          )}
        </Stack>

        <Stack
          direction="row"
          flexWrap="wrap-reverse"
          alignItems="center"
          justifyContent="flex-end"
          sx={{ mb: 5 }}
        >
          <Stack direction="row" spacing={1} flexShrink={0} sx={{ my: 1 }}>
            {session.administrator && (
              <ImportFile handleImportUser={(importedUser) => setImportedUser(importedUser)} />
            )}
            <TableFilterSidebar
              formik={formik}
              isOpenFilter={openFilter}
              onResetFilter={handleResetFilter}
              onOpenFilter={handleOpenFilter}
              onCloseFilter={handleCloseFilter}
              clubFilter
              statusFilter
              levelFilter
            />
          </Stack>
        </Stack>

        <Card>
          <UserListToolbar filterName={filterName} onFilterName={handleFilterByName} />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 300 }}>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={tableHead}
                  rowCount={users.length}
                  onRequestSort={handleRequestSort}
                />
                <TableBody>
                  {filteredUsers
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => {
                      const { id, email, phone, status, niveau, groupName } = row;
                      return (
                        <TableRow hover key={id + (groupName || 0)}>
                          <UserMoreInfo
                            user={row}
                            club={groupName}
                            status={status}
                            level={correspondLevel(niveau)}
                          />
                          <TableCell align="left" sx={{ display: tableHead[2].display }}>
                            {email}
                          </TableCell>
                          <TableCell align="left" sx={{ display: tableHead[3].display }}>
                            {phone}
                          </TableCell>
                          {niveau !== null ? (
                            <TableCell align="left" sx={{ display: tableHead[4].display }}>
                              <Label
                                variant="ghost"
                                color={(niveau === 'banned' && 'error') || 'info'}
                              >
                                {correspondLevel(niveau)}
                              </Label>
                            </TableCell>
                          ) : (
                            <TableCell align="left" sx={{ display: tableHead[4].display }} />
                          )}

                          <TableCell align="left" sx={{ display: tableHead[5].display }}>
                            <Label variant="ghost" color="success">
                              {status}
                            </Label>
                          </TableCell>

                          <TableCell align="left" sx={{ display: tableHead[6].display }}>
                            <Label variant="ghost" color="success">
                              {groupName}
                            </Label>
                          </TableCell>

                          {importedUser.length === 0 &&
                            !!(
                              permission.status === 0 ||
                              permission.status === 1 ||
                              session.administrator
                            ) && (
                              <TableCell align="right">
                                <UserMoreMenu id={id} />
                              </TableCell>
                            )}
                        </TableRow>
                      );
                    })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[10, 50, 100, 250, 500]}
            component="div"
            count={filteredUsers.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>
    </Page>
  );
}
